(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Client", [], factory);
	else if(typeof exports === 'object')
		exports["Client"] = factory();
	else
		root["Client"] = factory();
})(self, () => {
return 